import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  scannerContainer: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  scannerGrid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: 600,
  },
  scannerTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
  },
  searchLabel: {
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },
  codeReader: {
    "& > div": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  },
  toggleButtonRoot: {
    margin: theme.spacing(1),
    color: "white !important",
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  toggleButtonSelected: {
    backgroundColor: `${theme.palette.secondary.dark} !important`,
  },
  inputsGrid: {
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },
  },
  inputGrid: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  buttonGrid: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(1),
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  searchButton: {
    marginTop: -8,
  },
}));
